import styled from '@emotion/styled';
import type { MicrositeProfile } from '~/model';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
	background: #f3f4f6;
`;

const Card = styled.div`
	display: flex;
	gap: 1rem;
	background: white;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
	padding: 1rem;
`;

const List = styled.div`
	max-width: 72rem;
	margin: 0 auto;
	display: grid;
	gap: 1.5rem;
`;

const Photo = styled.img`
	width: 8rem;
	height: 8rem;
	object-fit: cover;
`;

const Info = styled.div`
	display: grid;
	gap: 0.25rem;
`;

export default function ProfileBlockEpsilon({ profiles }: { profiles: MicrositeProfile[] }) {
	if (profiles.length === 0) return null;

	return (
		<Section id="contact">
			<List>
				{profiles.map((profile) => (
					<Card key={profile.email ?? profile.name}>
						{profile.headshot?.medium_1x && <Photo src={profile.headshot.medium_1x} alt={profile.name} />}
						<Info>
							<strong>{profile.name}</strong>
							{profile.company && <span>{profile.company}</span>}
							{profile.phone && <span>{profile.phone}</span>}
							{profile.email && <span>{profile.email}</span>}
							{profile.license && <span>{profile.license}</span>}
						</Info>
					</Card>
				))}
			</List>
		</Section>
	);
}
